import React from 'react';
const Footer: React.FC = () => <footer className="reference-footer"><span>© {new Date().getFullYear()} Heretic</span></footer>;
export default Footer;
